<template>
	<div class="start-page-bg">
		<div class="container start-page-container">
			<div class="row d-flex align-items-center justify-content-center vh-100">
				<div class="card text-center col-xl-5 col-lg-6 col-md-8">
					<div class="card-body">

						<div class="row justify-content-center" style="height: 45%;">
							<img src="@/assets/img/spark_logo_black.svg" alt="spark_logo"
								class="img-fluid card-img-top w-75" />
						</div>

						<hr />

						<div class="row justify-content-center mt-3">
							<h3> Validating... </h3>
						</div>

					</div>
				</div>

			</div>


		</div>
	</div>

</template>

<script>
import jwt_decode from 'jwt-decode';
import { sortAlphabetically } from '@/plugins/helper.js';

export default {
    computed: {
        isSuperAdmin() {
            return this.$store.getters['auth/isSuperAdmin'] !== undefined
                ? this.$store.getters['auth/isSuperAdmin']
                : this.$store.state.auth.isSuperAdmin;
        },
        isAdmin() {
            return this.$store.getters['auth/isAdmin'] !== undefined
                ? this.$store.getters['auth/isAdmin']
                : this.$store.state.auth.isAdmin;
        },
        isConsultant() {
            return this.$store.getters['auth/isConsultant'] !== undefined
                ? this.$store.getters['auth/isConsultant']
                : this.$store.state.auth.isConsultant;
        },
        isGeneralUser() {
            return this.$store.getters['auth/isGeneralUser'] !== undefined
                ? this.$store.getters['auth/isGeneralUser']
                : this.$store.state.auth.isGeneralUser;
        },
        isOrgAdmin() {
            return this.$store.getters['auth/isOrgAdmin'] !== undefined
                ? this.$store.getters['auth/isOrgAdmin']
                : this.$store.state.auth.isOrgAdmin;
        },
        isSparkProductEnabled() {
            return this.$store.getters['auth/isSparkProductEnabled'] !== undefined
                ? this.$store.getters['auth/isSparkProductEnabled']
                : this.$store.state.auth.isSparkProductEnabled;
        },
        organisationId() {
            return this.$store.getters['auth/organisationId'] ||
                   this.$store.state.auth.currentUser?.organisation?.id ||
                   this.$store.state.auth.currentOrganisation?.id ||
                   '';
        },
    },

    async created() {
        await this.validate();
    },

    methods: {
        async validate() {
            const accessToken = this.$route.query.access_token;
            const refreshToken = this.$route.query.refresh_token;
            return this.validateToken(accessToken, refreshToken);
        },

        async validateToken(accessToken, refreshToken) {
            // 1. Redirect if no token is found
            if (!accessToken) {
                return this.$router.push({ name: 'index' });
            }

            try {
                // 2. Decode token and update store payload FIRST
                const decodedToken = jwt_decode(accessToken);
                this.$store.commit("auth/setJwtPayload", decodedToken);

                // 3. Scenario B: Org Admin in Spark-disabled organisation
                if (this.isOrgAdmin && !this.isSparkProductEnabled && !this.isSuperAdmin && !this.isAdmin && !this.isConsultant) {
                    await this.$store.dispatch('auth/redirectToAuthSettings');
                    return;
                }

                // 4. Scenario A: General User or no valid Spark role
                if (this.isGeneralUser || (!this.isSuperAdmin && !this.isAdmin && !this.isConsultant)) {
                    await this.$store.dispatch('auth/redirectToAuthSettings');
                    return;
                }

                this.$store.commit("auth/setAccessToken", accessToken);
                if (refreshToken) {
                    this.$store.commit("auth/setRefreshToken", refreshToken);
                }
                this.$store.commit("auth/authenticated", true);

                // 5. Fetch Vertex users list
                try {
                    await this.getVertexSuperAdminUsers2();
                } catch (e) {
                    console.warn("Could not fetch vertex super admin users:", e);
                }

                // 6. Redirect to the correct page
                const redirectLink = this.$store.state.auth.redirectLink;
                if (redirectLink) {
                    this.$store.commit("auth/setRedirectLink", null); // Clear link after use
                    this.$router.push({ path: redirectLink });
                } else {
                    this.$router.push({ name: 'dashboard' });
                }

            } catch (error) {
                // 7. Handle any errors during validation (e.g., bad token, API failure)
                console.error("Validation failed:", error);
                await this.$store.dispatch('auth/clearLocalSession');
                this.$router.push({ name: 'index', query: { error: 'invalid_session' } });
            }
        },

        async getVertexSuperAdminUsers2() {
            try {
                const response = await this.$axios.get("/auth/users/super-admin");
                if (response && response.data && response.data.super_admin_users) {
                    const users = response.data.super_admin_users;
                    sortAlphabetically(users, (item) => item.first_name);
                    this.$store.commit("auth/setUsersWithVertexRoles", users);
                }
            } catch (error) {
                console.error("Error fetching super admin users:", error);
                // Do not rethrow here to prevent aborting successful authentication
            }
        },
    },
};
</script>
